import LoadSessionView, { ILoadSessionViewProps } from "../Components/LoadSessionView";
import useGetSessionStart from "../hooks/useGetSessionStart";

const ObxLoadSessionView: React.FC<ILoadSessionViewProps> = props =>
  LoadSessionView({ ...props, useGetSessionStart: useGetSessionStart });

export default ObxLoadSessionView;
